import { Box, Typography, styled } from '@mui/material'
import { MButton, ProgressLoaders, SvgImage, Text } from 'components'
import { USER_TOKEN } from 'config'
import { color } from 'config/color'
import { useAuth } from 'context'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { formatValue, useLocalStorage } from 'utils'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { NoData } from './NoData'
import { BillItem, BillingHeader, StyledScrollbar } from './PaymentHistory'

export const BillingHistory = (): JSX.Element => {
  const isMobile = useMobileBreakpoints()
  const { account, currentAccount, isAdmin, userEmail, billingAccountHistory, getBillingAccountHistory } =
    useAuth()
  const [authToken] = useLocalStorage(USER_TOKEN, '')
  const [prevAccountId, setPrevAccountId] = useState<string>('')

  useEffect(() => {
    if (prevAccountId === currentAccount?.accountId || currentAccount?.accountId === billingAccountHistory?.accountId) {
      return
    }
    void getBillingAccountHistory({
      AccessToken: authToken,
      accountId: currentAccount?.accountId ?? account?.myAccount.accountId,
      startDate: dayjs().subtract(2, 'year').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      admin: isAdmin,
      email: userEmail
    })
    setPrevAccountId((currentAccount?.accountId ?? account?.myAccount?.accountId) ?? '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccount, userEmail, isAdmin, authToken])


  const handleBillClick = (_event: any, billUrl: string): void => {
    window.open(billUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <Wrapper>
      {(billingAccountHistory?.billing !== null) && billingAccountHistory?.billing.length === 0 && (
        <NoData transactionType="billing" />
      )}
      {billingAccountHistory !== null
        ? billingAccountHistory?.billing.length !== 0 && <>
          {isMobile
            ? billingAccountHistory?.billing.slice().reverse().map((bill, index) => {
              return <BillingEntryMobile key={index} date={bill.billDate} amount={bill.billAmount} url={bill.billDisplayURL} />
            })
            : <Box >
              <Box p={3}>
                <Typography color={color.grey[900]} fontSize={isMobile ? 18 : 24} fontWeight={600}>
                  Billing History
                </Typography>
              </Box>
              <BillingHeader>
                <ItemWrapper>Bill Date</ItemWrapper>
                <ItemWrapper>Bill Amount</ItemWrapper>
                <ItemWrapper>Bill Print File</ItemWrapper>
              </BillingHeader>
              <StyledScrollbar maxHeight="350px" overflow="auto">
                {billingAccountHistory?.billing.slice().reverse().map((bill, index) => {
                  return (
                    <BillItem key={index}>
                      <ItemWrapper small="true">{dayjs(bill.billDate).format('MM/YYYY')}</ItemWrapper>
                      <ItemWrapper small="true">{formatValue(bill.billAmount)}</ItemWrapper>
                      <ItemWrapper>
                        <Box display="flex" alignItems="center">
                          <MButton texttransform='none' onClick={(e) => { handleBillClick(e, bill.billDisplayURL) }}>
                            <Text fontSize="14px" color={color.grey[900]} margin="0 10px 0 0">
                              View Bill
                            </Text>
                            <SvgImage name="BillPdfIcon" width={24} height={24} />
                          </MButton>
                        </Box>
                      </ItemWrapper>
                    </BillItem>
                  )
                }
                )}
              </StyledScrollbar>
            </Box>}
        </>
        : <ProgressLoaders height="100%" />
      }
    </Wrapper >
  )
}

export const Wrapper = styled(Box)({
  background: color.white,
  padding: '24px 20px',
  marginBottom: '10px'
})

export const ItemWrapper = styled(Box)<{ small?: string }>(({ small }) => ({
  width: '25%',
  color: color.black,
  fontSize: small === 'true' ? '14px' : '16px',
  fontWeight: small === 'true' ? '400' : 'bold',
  display: 'flex',
  alignItems: 'center',
  gap: 5
}))

interface BillingEntryMobileProps {
  date: string
  amount: string
  url: string
}

const BillingEntryMobile: React.FC<BillingEntryMobileProps> = (props: BillingEntryMobileProps) => {
  return <Box py={2} borderBottom={`solid 1px ${color.background[50]}`}>
    <Box display="flex" justifyContent="space-between">
      <Typography fontSize={14} color={color.grey[700]}>Bill Date</Typography>
      <Typography fontSize={14} color={color.grey[900]} fontWeight={700}>{dayjs(props.date).format('MM-DD-YYYY')}</Typography>
    </Box>
    <Box display="flex" justifyContent="space-between">
      <Typography fontSize={14} color={color.grey[700]}>Payment Amount</Typography>
      <Typography fontSize={14} color={color.grey[900]} fontWeight={700}>{formatValue(props.amount)}</Typography>
    </Box>
    <Box display="flex" justifyContent="space-between">
      <Typography fontSize={14} color={color.grey[700]}>Bill Print Fle</Typography>
      <Typography fontSize={14} color={color.grey[900]} fontWeight={700}><MButton padding="0px" texttransform='none'><u>View Bill</u></MButton></Typography>
    </Box>
  </Box>
}
